export class Location {
  constructor(
    public id: number,
    public nome: string,
    public sigla: string
  ){}
}
export class Login{

public nome: string;
public nome_mae: string;
public data_nascimento: Date;
public cpf: string;

constructor(log: any = {}) {
  this.nome = log.nome || null;
  this.nome_mae = log.nome_mae || null;
  this.data_nascimento = log.data_nascimento || null;
  this.cpf = log.cpf || null;
}
public getName(): string {
  return this.nome;
}
public setName(nome: string): void {
  this.nome = nome;
}
public getNameMae(): string {
  return this.nome_mae;
}
public setNameMae(nome: string): void {
  this.nome_mae = nome;
}
public getData(): Date {
  return this.data_nascimento;
}
public setData(nome: Date): void {
  this.data_nascimento = nome;
}
public setCpf(cpf: string): void {
  this.cpf = cpf;
}
public getCpf(): string {
  return this.cpf;
}
}
export class Atualizacao{

public cpf: string;
public cep: string;
public complemento: string;
public bairro: string;
public rua: string;
public estado:  string;
public municipio:  number;
public numero:  number;
public telefone:  string;
public telefone_1:  string;
public telefone_2:  string;
public email:  string;
public email_1:  string;
public email_2:  string;
public contato:  string;
public contato_1:  string;
public contato_2:  string;


''
constructor(log: any = {}) {
  this.cpf = log.cpf || null;
  this.cep = log.cep || null;
  this.complemento = log.complemento || null;
  this.bairro = log.bairro || null;
  this.rua = log.rua || null;
  this.estado = log.estado || null;
  this.municipio = log.municipio || null;
  this.numero = log.numero || null;
  this.telefone = log.telefone || null;
  this.telefone_1 = log.telefone_1 || null;
  this.telefone_2 = log.telefone_2 || null;
  this.email = log.email || null;
  this.email_1 = log.email_1 || null;
  this.email_2 = log.email_2 || null;
  this.contato = log.contato || null;
  this.contato_1 = log.contato_1 || null;
  this.contato_2 = log.contato_2 || null;

}
public getcpf(): string {
  return this.cpf;
}
public setcpf(cpf: string): void {
  this.cpf = cpf;
}
public getCep(): string {
  return this.cep;
}
public setCep(cep: string): void {
  this.cep = cep;
}
public getcomplemento(): string {
  return this.complemento;
}
public setcomplemento(complemento: string): void {
  this.complemento = complemento;
}
public get_bairro(): string {
  return this.bairro;
}
public set_bairro(bairro: string): void {
  this.bairro = bairro;
}
public get_rua(): string {
  return this.rua;
}
public set_rua(rua: string): void {
  this.rua = rua;
}
public get_estado(): string {
  return this.estado;
}
public set_estado(estado: string): void {
  this.estado = estado;
}
public get_municipio(): number {
  return this.municipio;
}
public set_municipio(municipio: number): void {
  this.municipio = municipio;
}
public get_numero(): number {
  return this.numero;
}
public set_numero(numero: number): void {
  this.numero = numero;
}
public get_telefone1(): string {
  return this.telefone;
}
public set_telefone1(telefone: string): void {
  this.telefone = telefone;
}
public get_telefone_1(): string {
  return this.telefone_1;
}
public set_telefone_1(telefone_1: string): void {
  this.telefone_1 = telefone_1;
}
public get_telefone_2(): string {
  return this.telefone_2;
}
public set_telefone_2(telefone_2: string): void {
  this.telefone_2 = telefone_2;
}
public get_email(): string {
  return this.email;
}
public set_email(email: string): void {
  this.email = email;
}
public get_email_1(): string {
  return this.email_1;
}
public set_email_1(email_1: string): void {
  this.email_1 = email_1;
}
public get_email_2(): string {
  return this.email_2;
}
public set_email_2(email_2: string): void {
  this.email_2 = email_2;
}
public get_contato(): string {
  return this.contato;
}
public set_contato(contato: string): void {
  this.contato = contato;
}
public get_contato_1(): string {
  return this.contato_1;
}
public set_contato_1(contato_1: string): void {
  this.contato_1 = contato_1;
}
public get_contato_2(): string {
  return this.contato_2;
}
public set_contato_2(contato_2: string): void {
  this.contato_2 = contato_2;
}

}

